import { SITE } from "@/lib/site";
import { agencyNode, websiteNode } from "@/lib/schema/agency";

export function JsonLd() {
  const url = SITE.url;

  const organization = agencyNode();
  const websiteSchema = websiteNode();

  const serviceConstruction = {
    "@type": "Service",
    "@id": `${url}#service-construction-web-design`,
    serviceType: "Construction Website Design",
    name: "Construction Website Design",
    provider: { "@id": `${url}#organization` },
    areaServed: "GB",
    description:
      "Construction website design for UK builders, contractors and trades. £1,000 one-off fixed price, no subscription, live in 7 days. Includes custom domain and hosting setup, service pages, mobile-first design and on-page local SEO. The client owns the website.",
    offers: [
      {
        "@type": "Offer",
        name: "Website",
        priceCurrency: "GBP",
        price: "1000",
        availability: "https://schema.org/InStock",
      },
      {
        "@type": "Offer",
        name: "Website + Brand",
        priceCurrency: "GBP",
        price: "1399",
        availability: "https://schema.org/InStock",
      },
    ],
  };

  const serviceSeo = {
    "@type": "Service",
    "@id": `${url}#service-construction-seo`,
    serviceType: "SEO for Construction Companies",
    name: "Construction SEO",
    provider: { "@id": `${url}#organization` },
    areaServed: "GB",
    description:
      "SEO for UK construction companies and trades: Google Business Profile, local pages, reviews and technical fixes that help local customers find you. On-page local SEO is included in every £1,000 website.",
  };

  const breadcrumb = {
    "@type": "BreadcrumbList",
    "@id": `${url}#breadcrumb`,
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: url,
      },
    ],
  };

  const graph = {
    "@context": "https://schema.org",
    "@graph": [
      organization,
      websiteSchema,
      serviceConstruction,
      serviceSeo,
      breadcrumb,
    ],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(graph) }}
    />
  );
}
